import { vslMediaConfig, type ScheduleOffer } from "@/components/schedule-landing-page";
import { REVENUE_OPTIONS, type FormStep } from "@/components/schedule-lead-form";
import { CALENDLY_DEMO_AGENCY_URL } from "@/lib/cta";

/**
 * Shared copy for the two `/lp/schedule-agency` A/B arms (`…` and `…-b`).
 *
 * The H1 is the only variable under test, so it stays in each route file and
 * everything else lives here: a copy edit that lands on one arm only would
 * silently turn a single-variable headline test into a two-variable one.
 */

const OFFER: ScheduleOffer = {
  title: "Schedule Demo &\u00a0\nGet a Free AI Visibility Audit",
  paragraphs: [
    "We'll run an AI Visibility Audit for one of your clients and build your GEO roadmap on a 20-minute call.\n\nDuring the call we will discuss the report, current AI market share, what the LLMs are saying about the brand, and how to fix it.\n\nIf you want to take that blueprint and implement it yourself, you’re free to do so.",
  ],
};

/** Meta description — shared, since both arms sell the same offer. */
export const AGENCY_LP_DESCRIPTION =
  "Help your clients dominate ChatGPT, Perplexity and Search GPT. Book an agency demo and get a free AI Visibility Audit for one of your target clients.";

const STEPS: FormStep[] = [
  {
    type: "choice",
    key: "industry",
    eyebrow: "Qualify",
    title: "What industry are your customers in?",
    options: ["B2B software", "Ecommerce", "Local business", "Other"],
  },
  {
    type: "choice",
    key: "revenueRange",
    eyebrow: "Qualify",
    title: "Annual revenue range?",
    options: REVENUE_OPTIONS,
  },
  {
    type: "choice",
    key: "clientCount",
    eyebrow: "Qualify",
    title: "How many clients do you have?",
    options: ["0 - 10", "10 - 30", "31 - 80", "81+"],
  },
  {
    type: "url",
    key: "exampleClient",
    eyebrow: "Last step",
    title: "An example client we'll run the audit on.",
    description:
      "Ahead of the call we'll run an in-depth AI Visibility Audit for this client so you can see Axy.digital in action.",
    placeholder: "https://client-website.com",
  },
];

/** Every `ScheduleLandingPage` prop except `title`. Spread into both arms. */
export const AGENCY_LP_SHARED = {
  subtitle:
    "Help your clients dominate ChatGPT, Perplexity, Gemini and Claude. Axy.digital handles 100% of the research, content generation, and tracking on autopilot.\n",
  offer: OFFER,
  trustLabel: "Join the 100+ agencies already using Axy.digital",
  formName: "schedule-agency",
  steps: STEPS,
  video: vslMediaConfig("vsl-schedule-agency-v2"),
  calendlyUrl: CALENDLY_DEMO_AGENCY_URL,
};
